import { useMemo } from "react";

import type { ICampaignsScrapingConfiguration } from "app/components/campaigns/shared/CampaignsConst";
import type { IKeyword } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

export const useCountNewTrackedSearches = (
    keywords: IKeyword[],
    resolvedScrapingConfigs: ICampaignsScrapingConfiguration[],
): number => {
    return useMemo(() => {
        const trimmed = keywords.filter((kw) => kw.value.trim().length > 0);
        return resolvedScrapingConfigs.reduce((sum, config) => {
            const existingSet = new Set(config.keywords.map((kw) => kw.toLowerCase().trim()));
            return sum + trimmed.filter((kw) => !existingSet.has(kw.value.toLowerCase().trim())).length;
        }, 0);
    }, [keywords, resolvedScrapingConfigs]);
};
